import script from "./NewsPageNewsFeed.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageNewsFeed.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageNewsFeed.vue?vue&type=style&index=0&id=6c3fc6e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c3fc6e0"]])

export default __exports__